import React, { useEffect } from 'react'
import 'react-circular-progressbar/dist/styles.css'

import { AttachmentFile } from './AttachmentFile'
import { useAttachmentFiles } from './useAttachmentFiles'
import { CircularProgressbar } from './CircularProgressbar'
import { AttachmentFilesStatus } from './AttachmentFilesStatus'

import { usePrevious } from '../../../hooks/usePrevious'

import { CloseWidgetIcon } from '../../../icons/Icons'

import { useStatus } from './useStatus'
import { getLoadedFilesMessageFormat } from './getLoadedFilesMessageFormat'

export const AttachmentFiles = props => {
  const { classes } = props
  const { files, getFiles, removeFile, loadedFiles, updateLoadedFiles } =
    useAttachmentFiles()
  const { status, countErrorFiles, percentUploadFiles } = useStatus(
    files,
    loadedFiles,
  )
  const prevFilesLength = usePrevious(files.length)

  const isDisabledButton = status !== 'success'

  useEffect(() => {
    getFiles(props.filesForUpload)
  }, [props.filesForUpload])

  useEffect(() => {
    if (files.length === 0 && prevFilesLength > 0) {
      props.resetAttachmentFiles()
    }
  }, [files])

  const sendFiles = () => {
    props.postMessage(getLoadedFilesMessageFormat(loadedFiles, props.isRtl))
    props.resetAttachmentFiles()
  }

  return (
    <div className={classes.outerContainer}>
      <div className={classes.container}>
        <div className={classes.header}>
          <AttachmentFilesStatus
            files={files}
            status={status}
            percentUpload={percentUploadFiles}
            loadedFiles={loadedFiles}
            countErrorFiles={countErrorFiles}
          />
          <div
            onClick={props.resetAttachmentFiles}
            style={{ cursor: 'pointer', display: 'flex' }}>
            <CloseWidgetIcon width={24} height={24} color="#000" />
          </div>
        </div>
        <div className={classes.main}>
          {files.length > 0 &&
            files.map(file => (
              <AttachmentFile
                file={file}
                key={file.name}
                removeFile={removeFile}
                updateLoadedFiles={updateLoadedFiles}
              />
            ))}
        </div>
        <div className={classes.footer}>
          <button
            onClick={sendFiles}
            className={classes.sendButton}
            disabled={isDisabledButton}
            style={{ background: props.color }}>
            {status === 'loading' && (
              <div style={{ marginRight: 8 }}>
                <CircularProgressbar value={percentUploadFiles} />
              </div>
            )}
            Send files
          </button>
        </div>
      </div>
    </div>
  )
}
